export default () => {   
    // obtain parent tag select and his children options 
    let values = $('.size-value'),
        valueList = $('#js-features');      
    // our IIFE sort 
    (() => {
        valueList.hasClass('custom') ?
            values.sort((a,b) => $(a).attr('data-size').replace(/[^0-9]/g, '') - $(b).attr('data-size').replace(/[^0-9]/g, ''))
            :  values.sort((a,b) => $(a).attr('data-size') - $(b).attr('data-size'));        
        valueList.append(values);
        return valueList
    })()   
}